// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Nqgu","colMin":"styles_colMin__1whwo"};